import React from 'react';
import SectionHeader from '@/components/site/SectionHeader';
import GoldText from '@/components/site/GoldText';
import { processStages } from '@/content/process';

const HowItWorks = () => (
  <section id="how-it-works" aria-labelledby="how-title" className="scroll-mt-20 border-t border-rule">
    <div className="section-container">
      <SectionHeader
        id="how-title"
        eyebrow="05 / How it works"
        title={
          <>
            From business problem <GoldText>to working pilot.</GoldText>
          </>
        }
      />

      <ol className="reveal relative mt-16 grid gap-8 lg:grid-cols-5 lg:gap-6">
        <span
          aria-hidden="true"
          className="absolute left-0 right-0 top-[1.1rem] hidden h-px bg-[repeating-linear-gradient(90deg,#e9b864_0_4px,transparent_4px_8px)] opacity-50 lg:block"
        />
        {processStages.map((s, i) => (
          <li key={s.stage} className="relative grid grid-cols-[2.25rem_1fr] gap-4 lg:block">
            <span className="relative z-10 flex h-9 w-9 items-center justify-center rounded-full border-2 border-goldcore bg-knightblack font-mono text-xs text-goldcore shadow-[0_0_0_4px_rgba(233,184,100,0.12)] lg:mb-6">
              0{i + 1}
            </span>
            <div>
              <h3 className="mb-2 text-3xl">{s.stage}</h3>
              <p className="mb-4 text-mist">{s.copy}</p>
              <p className="meta-label">Output</p>
              <p className="text-sm text-softwhite">{s.output}</p>
            </div>
          </li>
        ))}
      </ol>

      <p className="reveal mt-16 max-w-3xl font-serif text-2xl leading-snug text-softwhite sm:text-3xl">
        The goal is not to automate everything. It is to make a well-defined part of your business work better—
        <GoldText>and understand the tradeoffs.</GoldText>
      </p>
    </div>
  </section>
);

export default HowItWorks;
